import { Variant } from '../models/variant.model';
import { mapInteriorObjectFromEditorObject } from './mapInteriorObjectFromEditorObject';
import { EditorObject } from '../models/editor-object.model';
import { Floor } from '../models/floor.model';
import { ComponentNames } from './componentNames';
import { BaseDimensionComponent } from '../models/components/commonComponents/BaseDimensionComponent';
import { AxisEnum } from '../models/enums/AxisEnum';
import { konvaPositionToTopLeftObjectCornerPosition } from './positionMapper';
import { getComponentFromSource } from '../generics-helper/getComponentFromSource.generic';
import { mapDegreeToStep } from './mapDegreeToStep';
import { DoNotSaveComponent } from '../models/components/commonComponents/DoNotSaveComponent';
import { FloorComponent } from '../models/components/containerComponents/FloorComponent';

export function changeEditorVariantFloorStructureToVariantFloorStructure(variant: Variant): Variant {
  var floors = new Array();
  variant.floors.forEach(eFloor => {
    var floor = new Floor();
    floor.floorType = eFloor.floorType;
    floor.elements = new Array();
    eFloor.elements.forEach((el: EditorObject) => {

      let dNSComp = getComponentFromSource<DoNotSaveComponent>(ComponentNames.doNotSaveComponent, el.components);
      if (dNSComp != null) {
        // console.log("found object which shouldn't be saved!");
        let floorComponent = getComponentFromSource<FloorComponent>(ComponentNames.floorComponent, el.components);
        if (floorComponent != null) {
          floor.floorImageBase64Data = floorComponent.floorImageBase64Data;
          floor.isFloorImageVisible = floorComponent.isFloorImageVisible;
          floor.floorImageOpacity = el.opacity();
        }
        return;
      }
      let interiorObject = mapInteriorObjectFromEditorObject(el);

      // mapping for top left cornor position
      let baseDimensionsComponent = interiorObject.getComponent(ComponentNames.baseDimensionsComponent) as BaseDimensionComponent;
      baseDimensionsComponent.posX = konvaPositionToTopLeftObjectCornerPosition(baseDimensionsComponent.posX, AxisEnum.X, baseDimensionsComponent.box, baseDimensionsComponent.rotation);
      baseDimensionsComponent.posY = konvaPositionToTopLeftObjectCornerPosition(baseDimensionsComponent.posY, AxisEnum.Y, baseDimensionsComponent.box, baseDimensionsComponent.rotation);
      // mapping from degree into rotation step
      baseDimensionsComponent.rotation = mapDegreeToStep(baseDimensionsComponent.rotation);

      floor.elements.push(interiorObject);
    });
    floors.push(floor);
  });

  variant.floors = floors;

  return variant;
}